module.exports = __webpack_public_path__ + "img/index-5.ff800874.png";